import { CircleLayer, PopupProps, SymbolLayer } from "react-map-gl";

export const SOURCE_ID = "article-source";
export const RENDERED_LAYER_ID = "rendered-points";
export const ALL_POINTS_LAYER_ID = "all-points";

export const SELECTED_POINT_COLOUR_DARK = "#D35858";
export const SELECTED_POINT_COLOUR_LIGHT = "#E59C9C";

export const BOUNDS_PADDING = 30;
export const CLICK_TOLERANCE_PX = 6;
export const MIN_ZOOM_CLICK = 8;
export const MAX_EXPANSION_ZOOM = 14;
export const CLUSTER_RADIUS = 15;

export const CLUSTER_COUNT_LAYER: Omit<SymbolLayer, "source"> = {
  id: "cluster-count",
  type: "symbol",
  layout: {
    "text-allow-overlap": true,
    "text-field": ["get", "point_count_abbreviated"],
    "text-size": 15,
  },
  paint: {
    "text-color": "white",
    "text-halo-color": "white",
    "text-halo-width": 0.5,
  },
};

export function POINT_LAYER(
  selectedId: string | number | null,
  isCluster: boolean
): Omit<CircleLayer, "source"> {
  return {
    id: RENDERED_LAYER_ID,
    type: "circle",
    paint: {
      "circle-radius": [
        "step",
        ["number", ["get", "point_count"], 0],
        7,
        1,
        10,
        10,
        15,
        20,
        20,
      ],
      "circle-stroke-color":
        selectedId != null
          ? [
              "case",
              ["==", ["get", isCluster ? "cluster_id" : "id"], selectedId],
              SELECTED_POINT_COLOUR_DARK,
              "#236099",
            ]
          : "#236099",
      "circle-stroke-width": 4,
      "circle-stroke-opacity": 0.7,
      "circle-opacity": 0.6,
      "circle-color":
        selectedId != null
          ? [
              "case",
              ["==", ["get", isCluster ? "cluster_id" : "id"], selectedId],
              SELECTED_POINT_COLOUR_DARK,
              "#236099",
            ]
          : "#236099",
    },
  };
}

export const POPUP_OFFSET: PopupProps["offset"] = {
  top: [0, 7],
  "top-left": [7, 7],
  "top-right": [-7, 7],
  bottom: [0, -7],
  "bottom-left": [7, -7],
  "bottom-right": [-7, -7],
  left: [7, 0],
  right: [-7, 0],
};
